import { useEffect } from 'react';

const GoogleAnalytics = ({ measurementId, searchConsoleCode }) => {
  useEffect(() => {
    // Load Google Analytics if ID is provided
    if (measurementId && measurementId.startsWith('G-')) {
      // Check if script already exists
      const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`);
      
      if (!existingScript) {
        // Add gtag script
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        script.async = true;
        document.head.appendChild(script);

        // Add gtag config
        const configScript = document.createElement('script');
        configScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        document.head.appendChild(configScript);

        console.log('✅ Google Analytics loaded:', measurementId);
      }
    }

    // Add Google Search Console verification meta tag
    if (searchConsoleCode) {
      let metaTag = document.querySelector('meta[name="google-site-verification"]');
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'google-site-verification');
        document.head.appendChild(metaTag);
      }
      
      metaTag.setAttribute('content', searchConsoleCode);
      console.log('✅ Google Search Console verification tag added');
    }
  }, [measurementId, searchConsoleCode]);

  return null;
};

export default GoogleAnalytics;
